import { useNotificationDetailRedirect } from "@/pages/notification-detail/fetch";

type Props = {
  id: number;
};

export const NotificationDetailPage = ({ id }: Props) => {
  useNotificationDetailRedirect(id);

  return null;
};
